import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { t } from '../../translations/getTranslation';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import CardInfo from '../../components/cards/CardInfo';
import Calendar from '../../components/Calendar';
import useSteps from '../../context/steps.context';
import useTypesafeAnswer from '../../hooks/useTypesafeAnswer';
import { createLocalDate, dateToISOString, isValidDateFormat, minDate, parseLocalDate } from '../../helpers/formatDate';
const RequestReplacementButton = styled.button `
  color: ${({ theme }) => theme.colors.cyanBlue};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
const CalendarContainer = styled.div `
  margin: ${({ theme }) => `${theme.spacing.base}px 0 ${theme.spacing.small}px 0`};
`;
const WhenLost = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    const { stepsState: { answers, error }, stepsDispatch } = useSteps();
    const [tempDate, setTempDate] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormatError, setIsFormatError] = useState(false);
    useAnalytics(isSuccess, { isSemu });
    const { currentAnswer: selectedDate } = useTypesafeAnswer('WhenLost');
    const today = createLocalDate();
    useEffect(() => {
        if (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.value) {
            setTempDate(selectedDate.value);
        }
    }, [selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.value]);
    const handleOnChange = (date) => {
        if (date) {
            const storageString = dateToISOString(date);
            stepsDispatch({
                type: 'updateAnswer',
                payload: { step: 'WhenLost', value: storageString }
            });
            setTempDate(storageString);
            setIsFormatError(false);
            stepsDispatch({ type: 'clearError' });
        }
    };
    const handleOnBlur = (date) => {
        if (!date && !isModalOpen) {
            setTempDate('');
            setIsFormatError(false);
            stepsDispatch({ type: 'throwError' });
            stepsDispatch({
                type: 'updateAnswer',
                payload: { step: 'WhenLost', value: '' }
            });
        }
        else if (date) {
            if (!isValidDateFormat(date)) {
                setTempDate('');
                setIsFormatError(true);
                stepsDispatch({ type: 'throwError' });
                return;
            }
            const storageString = dateToISOString(new Date(date));
            stepsDispatch({
                type: 'updateAnswer',
                payload: { step: 'WhenLost', value: storageString }
            });
            setTempDate(storageString);
            setIsFormatError(false);
            stepsDispatch({ type: 'clearError' });
        }
    };
    const handleClick = () => {
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        const todayStorage = dateToISOString(today);
        setTempDate(todayStorage);
        setIsFormatError(false);
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: 'WhenLost', value: todayStorage }
        });
    };
    const getFormError = () => {
        if (!error)
            return '';
        if (isFormatError) {
            return t('whenLost.dateMustBeValid');
        }
        if (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.value) {
            const selectedDateObj = parseLocalDate(selectedDate.value);
            if (selectedDateObj && selectedDateObj.getTime() < minDate.getTime()) {
                return t('whenLost.dateCannotBeBeforeMinimum');
            }
            return t('whenLost.futureDate');
        }
        return t('whenLost.pleaseSelect');
    };
    const formError = getFormError();
    const formatSelectedDate = () => {
        if (!tempDate)
            return null;
        return parseLocalDate(tempDate);
    };
    const getTitle = (array) => {
        var _a;
        return ((_a = array[0]) === null || _a === void 0 ? void 0 : _a.value) === 'lost-card'
            ? t('whenLost.lostCardTitle')
            : t('whenLost.cardStolenTitle');
    };
    return (_jsxs(_Fragment, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ maxWidth: 408, withImage: true }, { children: [_jsx(LayoutHeading, { title: getTitle(answers), modalImageProps: { imageName: 'DISPUTE_TRANSACTION' } }), _jsx(CalendarContainer, { children: _jsx(Calendar, { setModalIsOpen: setIsModalOpen, error: formError, onChange: handleOnChange, placeholderLabel: "Date (mm/dd/yyyy)", 
                            /* eslint-disable @typescript-eslint/ban-ts-comment */
                            /* @ts-ignore */
                            selectedDate: formatSelectedDate(), endDate: today, onBlur: handleOnBlur, startDate: createLocalDate(minDate) }) }), _jsx(RequestReplacementButton, Object.assign({ onClick: handleClick }, { children: t('whenLost.dontKnow') }))] }))] }));
};
export default WhenLost;
//# sourceMappingURL=index.js.map